var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 8,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7346_63657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9097 18.613V39.017C46.9097 39.8906 46.2015 40.5987 45.328 40.5987H42.9475C42.515 40.5987 42.1645 40.9492 42.1645 41.3816V44.5261C42.1645 44.9446 41.6586 45.1542 41.3626 44.8583L37.3323 40.828C37.1855 40.6812 36.9864 40.5987 36.7788 40.5987H20.0207C19.1471 40.5987 18.439 39.8906 18.439 39.017V18.613C18.439 17.7394 19.1471 17.0312 20.0207 17.0312H45.328C46.2015 17.0312 46.9097 17.7394 46.9097 18.613Z",
    fill: "#1985A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0207 17.0312C19.1471 17.0312 18.439 17.7394 18.439 18.613V35.6954H34.8887C36.9819 35.6954 38.6848 33.9924 38.6848 31.8993V17.0312H20.0207Z",
    fill: "#1B758C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.4948V31.8988C8 32.7724 8.70813 33.4805 9.58171 33.4805H11.9622C12.3946 33.4805 12.7451 33.831 12.7451 34.2634V37.4079C12.7451 37.8265 13.2511 38.036 13.547 37.7401L17.5773 33.7098C17.7242 33.563 17.9233 33.4805 18.1309 33.4805H34.889C35.7626 33.4805 36.4707 32.7724 36.4707 31.8988V11.4948C36.4707 10.6212 35.7626 9.91309 34.889 9.91309H9.58171C8.70813 9.91309 8 10.6212 8 11.4948H8Z",
    fill: "#FFD301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.471 31.8988V11.4948C36.471 10.6212 35.7629 9.91309 34.8893 9.91309H32.4632C32.0202 14.8572 30.1132 27.1522 21.9731 33.4805H34.8893C35.7629 33.4805 36.471 32.7723 36.471 31.8988Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2528 25.8488C21.554 25.8488 20.9875 25.2822 20.9875 24.5834V20.9896C20.9875 20.2907 21.554 19.7243 22.2528 19.7243C22.9045 19.7243 23.511 19.4635 23.9606 18.99C24.4098 18.5168 24.6386 17.8962 24.6046 17.2422C24.5411 16.0178 23.5297 15.0395 22.3021 15.0147C21.109 14.9928 20.085 15.861 19.9206 17.0392C19.9055 17.1475 19.8979 17.2585 19.8979 17.3692C19.8979 18.0681 19.3313 18.6345 18.6325 18.6345C17.9337 18.6345 17.3672 18.068 17.3672 17.3692C17.3672 17.142 17.383 16.9133 17.4142 16.6894C17.7558 14.2423 19.8766 12.4327 22.3532 12.4845C24.9009 12.5358 27.0001 14.568 27.1321 17.1111C27.2023 18.465 26.7279 19.7511 25.7961 20.7325C25.1736 21.3881 24.38 21.8543 23.5184 22.0867V24.5834C23.5182 25.2822 22.9517 25.8488 22.2528 25.8488Z",
    fill: "#ECF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2526 30.9106C22.9515 30.9106 23.518 30.344 23.518 29.6452C23.518 28.9464 22.9515 28.3799 22.2526 28.3799C21.5538 28.3799 20.9873 28.9464 20.9873 29.6452C20.9873 30.344 21.5538 30.9106 22.2526 30.9106Z",
    fill: "#ECF4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7346_63657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.91,
    height: 38.91,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.4601642a093f0902791ce357c44ce760.svg";
export { ForwardRef as ReactComponent };